import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

function PrivateMenuItem({ permissionName, name, ...rest }) {
  const menuPermissions = useSelector(
    state => state.session.permission.permissions
  ).get('MENU');

  if (menuPermissions && menuPermissions.has(permissionName)) {
    return <NavLink {...rest}>{name}</NavLink>;
  }

  return null;
}

PrivateMenuItem.propTypes = {
  permissionName: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default PrivateMenuItem;
